import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule, PageComponentModule, SpinnerModule } from '@spartacus/storefront';
import { CustomGenericLinkModule } from 'src/app/spartacus/custom/shared/components/custom-generic-link/custom-generic-link.module';
import { CustomIconsModule } from "../../../icons/custom-icons.module";
import { CustomFamiliesComponent } from './custom-families.component';
import { FAMILIES_FEATURE } from './store/custom-families-state';
import { effectsFamilies } from './store/effects/custom-families.effect';
import { reducerFamiliesProvider, reducerFamiliesToken } from './store/reducers/custom-families.reducer';


@NgModule({
  declarations: [CustomFamiliesComponent],
  exports: [CustomFamiliesComponent],
  imports: [
    CommonModule,
    SpinnerModule,
    I18nModule,
    RouterModule,
    UrlModule,
    CustomGenericLinkModule,
    MediaModule,
    CustomIconsModule,
    PageComponentModule,
    EffectsModule.forFeature(effectsFamilies),
    StoreModule.forFeature(FAMILIES_FEATURE, reducerFamiliesToken),
    ConfigModule.withConfig({
      cmsComponents: {
        FamiliesComponent: {
          component: CustomFamiliesComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [reducerFamiliesProvider],
})
export class CustomFamiliesModule { }
